<template>
  <a-row ref="head-section" class="head-section">
    <a-col v-if="title || breadcrumbs.length" :span="10">
      <a-breadcrumb v-if="breadcrumbs.length">
        <a-breadcrumb-item v-for="breadcrumb in breadcrumbs" :key="breadcrumb.name">
          <div v-if="loading" class="d-inline-block">
            <Skeleton class="w-fit" width="80px" />
          </div>
          <a
            v-else-if="breadcrumb.link"
            :class="viewPermissions ? 'head-section__breadcrumb__active' : 'head-section__breadcrumb'"
            @click="breadcrumbClick(breadcrumb.link)"
          >
            {{ breadcrumb.name }}
          </a>
          <span v-else class="head-section__breadcrumb">{{ breadcrumb.name }}</span>
        </a-breadcrumb-item>
      </a-breadcrumb>
      <div class="d-flex align-items-end" :class="{ 'mt-2': breadcrumbs.length }">
        <h3 v-if="title" class="head-section__title">{{ title }}</h3>
        <slot v-if="editPermissions" name="activeSwitch" />
      </div>
      <div v-if="uuid" class="mt-2">
        <span class="head-section__uuid"><span class="font-weight-bold">UUID</span>: {{uuid}}</span>
        <a-icon
          type="copy"
          class="font-size-14 text-primary cursor-pointer ml-2"
          @click="copy(uuid, 'UUID copied to clipboard')"
        />
      </div>
    </a-col>
    <slot v-if="editPermissions" name="actions" />
  </a-row>
</template>

<script>
import { mapState } from 'vuex'
import { copyToClipboard } from '@/composables/copy/copyToClipboard.js'
import useCheckPermissions from '@/services/useCheckPermissions.js'
import Skeleton from '@/components/custom/skeleton/Skeleton.vue'

export default {
  mixins: [useCheckPermissions],
  props: {
    title: {
      type: String,
      default: '',
    },
    breadcrumbs: {
      type: Array,
      default: () => [],
    },
    uuid: {
      type: String,
      default: '',
    },
    permissionOfSection: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    Skeleton,
  },
  computed: {
    ...mapState(['user']),
    viewPermissions() {
      return !this.permissionOfSection || this.checkPermissions(this.user.permissions, this.permissionOfSection, 'view')
    },
    editPermissions() {
      return !this.permissionOfSection || this.checkPermissions(this.user.permissions, this.permissionOfSection, 'edit')
    },
  },
  methods: {
    breadcrumbClick(link) {
      if (!this.viewPermissions) {
        return
      }
      this.$router.push(link)
    },
    copy(value, message) {
      copyToClipboard(value, message)
    },
    checkScrollWindow() {
      const scrollPageValue = window?.scrollY
      if (scrollPageValue > 0) {
        this.$refs['head-section'].$el.classList.add('head-section__scroll')
      } else {
        this.$refs['head-section'].$el.classList.remove('head-section__scroll')
      }
    },
  },
  mounted() {
    document.addEventListener('scroll', this.checkScrollWindow)
  },
  beforeDestroy() {
    document.removeEventListener('scroll', this.checkScrollWindow)
  },
}
</script>

<style lang="scss">
.head-section {
  position: sticky !important;
  top: 64px;
  z-index: 997;
  display: flex !important;
  align-items: center;
  margin: -30px -30px 1.5rem -30px !important;
  padding: 22px 30px 22px 30px;
  background-color: #fff;
  border-top: 1px solid #f0f2f6;
  border-bottom: 1px solid #f0f2f6;
  transition: all .5s ease-out;
  &__scroll {
    padding: 8px 30px;
  }
  &__title {
    font-size: 20px;
    margin-bottom: 0;
  }
  &__uuid {
    font-size: 14px;
    color: #8C8C8C,
  }
  &__breadcrumb {
    color: #00000073;
    &:hover {
      cursor: default;
    }
    &__active {
      color: #1890FF !important;
      &:hover {
        cursor: pointer;
      }
    }
  }
}
</style>
